// extracted by mini-css-extract-plugin
export var barContainer = "_2o-0";
export var extraThin = "_2o-3";
export var fillBar = "_2o-6";
export var fillContainer = "_2o-4";
export var overflow = "_2o-8";
export var overflowContainer = "_2o-5";
export var regular = "_2o-7";
export var thick = "_2o-1";
export var thin = "_2o-2";